import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

const SmoothWavyDivider: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        lineHeight: 0,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <svg
        viewBox="0 0 1200 200"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'relative',
          display: 'block',
          width: '100%',
          height: '100px', // Adjusted height for smoother curve
        }}
      >
        <path
          d="M0,50 C300,150 900,-50 1200,50 L1200,200 L0,200 Z"
          fill={theme.palette.primary.main}
          opacity="0.4"
        />
        <path
          d="M0,100 C300,200 900,0 1200,100 L1200,200 L0,200 Z"
          fill={theme.palette.background.default}
          opacity="0.6"
        />
        <path
          d="M0,150 C300,250 900,50 1200,150 L1200,200 L0,200 Z"
          fill={theme.palette.background.default}
          opacity="0.5"
        />
      </svg>
    </Box>
  );
};

export default SmoothWavyDivider;
